/**
 * Created by rathompson on 1/21/22
 * File: IAMReducer.actions.js
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import type { Action } from './index'
import type {
  IAM_APIRole,
  IAM_APIPermission,
  IAM_APICustomRole,
  IAM_APIPermissionSet,
  IAM_APIAccessPolicy,
  IAM_APIServiceAccount,
  IAM_CustomRoleMetaData,
  IAM_FederationMapping,
  IAM_API_AllowedIp,
} from '../types/IAMReducer.types'

export const SET_ROLES = 'SET_ROLES'
export const SET_PERMISSIONS = 'SET_PERMISSIONS'
export const SET_ACCESS_POLICIES = 'SET_ACCESS_POLICIES'
export const SET_SERVICE_ACCOUNTS = 'SET_SERVICE_ACCOUNTS'
export const SET_CUSTOM_ROLES = 'SET_CUSTOM_ROLES'
export const SET_PERMISSION_SETS = 'SET_PERMISSION_SETS'
export const SET_CUSTOM_ROLE_METADATA = 'SET_CUSTOM_ROLE_METADATA'
export const SET_FEDERATION_MAPPINGS = 'SET_FEDERATION_MAPPINGS'
export const IAM_RESET = 'IAM_RESET'
export const SET_ALLOWED_IPS = 'SET_ALLOWED_IPS'
export const SET_IP_LIMIT = 'SET_IP_LIMIT'

export type ActionSetRoles = { roles: IAM_APIRole[] } & Action
export const setRoles: (roles: IAM_APIRole[]) => ActionSetRoles = (roles: IAM_APIRole[] = []) => ({
  type: SET_ROLES,
  roles
})

export type ActionSetPermissions = { permissions: IAM_APIPermission[] } & Action
export const setPermissions: (permissions: IAM_APIPermission[]) => ActionSetPermissions = (permissions: IAM_APIPermission[] = []) => ({
  type: SET_PERMISSIONS,
  permissions
})

export type ActionSetAccessPolicies = { accessPolicies: IAM_APIAccessPolicy[] } & Action
export const setAccessPolicies: (accessPolicies: IAM_APIAccessPolicy[]) => ActionSetAccessPolicies = (accessPolicies: IAM_APIAccessPolicy[] = []) => ({
  type: SET_ACCESS_POLICIES,
  accessPolicies
})

export type ActionSetServiceAccounts = { serviceAccounts: IAM_APIServiceAccount[] } & Action
export const setServiceAccounts: (serviceAccounts: IAM_APIServiceAccount[]) => ActionSetServiceAccounts = (serviceAccounts: IAM_APIServiceAccount[] = []) => ({
  type: SET_SERVICE_ACCOUNTS,
  serviceAccounts
})

export type ActionSetCustomRoles = { customRoles: IAM_APICustomRole[] } & Action
export const setCustomRoles: (customRoles: IAM_APICustomRole[]) => ActionSetCustomRoles = (customRoles: IAM_APICustomRole[] = []) => ({
  type: SET_CUSTOM_ROLES,
  customRoles
})

export type ActionSetPermissionSets = { permissionSets: IAM_APIPermissionSet[] } & Action
export const setPermissionSets: (permissionSets: IAM_APIPermissionSet[]) => ActionSetPermissionSets = (permissionSets: IAM_APIPermissionSet[] = []) => ({
  type: SET_PERMISSION_SETS,
  permissionSets
})

export type ActionSetCustomRoleMetaData = { metadata: IAM_CustomRoleMetaData } & Action
export const setCustomRoleMetaData: (metadata: IAM_CustomRoleMetaData) => ActionSetCustomRoleMetaData = (metadata) => ({
  type: SET_CUSTOM_ROLE_METADATA,
  metadata
})

export type ActionSetFederationMappings = { federationMappings: IAM_FederationMapping[] } & Action
export const setFederationMappings: (federationMappings: IAM_FederationMapping[]) => ActionSetFederationMappings = (federationMappings: IAM_FederationMapping[] = []) => ({
  type: SET_FEDERATION_MAPPINGS,
  federationMappings
})

export type ActionSetAllowedIps = { allowedIps: IAM_API_AllowedIp[] } & Action
export const setAllowedIps: (allowedIps: IAM_API_AllowedIp[]) => ActionSetAllowedIps = (allowedIps: IAM_API_AllowedIp[] = []) => ({
  type: SET_ALLOWED_IPS,
  allowedIps
})

export type ActionSetTrustedIPLimit = { trustedIPLimit: number } & Action
export const setTrustedIPLimit: (trustedIPLimit: number) => ActionSetTrustedIPLimit = (trustedIPLimit: number = 20) => ({
  type: SET_IP_LIMIT,
  trustedIPLimit
})


export const resetIAMReducer = () => ({ type: IAM_RESET })
